import { render, staticRenderFns } from "./PappyonPremiere.vue?vue&type=template&id=43ae0726"
import script from "./PappyonPremiere.vue?vue&type=script&lang=js"
export * from "./PappyonPremiere.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports